import { useMemo } from 'react';
import { COMPOSITION_DIMENSIONS, VIDEO_QUALITY } from '@/App/remotion/constants';
import { SizeType } from '@/domains/asset';

export default function usePlayerAspectRatio({ size }: { size: SizeType }) {
  const { compositionHeight, compositionWidth } = useMemo(() => {
    const videoQuality = VIDEO_QUALITY.FULL_HD;
    const compositionHeight = COMPOSITION_DIMENSIONS[size][videoQuality].HEIGHT;
    const compositionWidth = COMPOSITION_DIMENSIONS[size][videoQuality].WIDTH;

    return {
      compositionHeight,
      compositionWidth
    };
  }, [size]);

  return {
    compositionHeight,
    compositionWidth,
    playerAspectRatio: compositionWidth / compositionHeight
  };
}
